import { render, staticRenderFns } from "./ChatUser.vue?vue&type=template&id=17aad6a4&scoped=true&"
import script from "./ChatUser.vue?vue&type=script&lang=js&"
export * from "./ChatUser.vue?vue&type=script&lang=js&"
import style0 from "./ChatUser.vue?vue&type=style&index=0&id=17aad6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aad6a4",
  null
  
)

export default component.exports